
import { useLanguage } from '@/hooks/useLanguage';
import { Check, Loader2 } from 'lucide-react';

interface CVEStatusIndicatorProps {
  isSearching: boolean;
  loadingYears: Record<number, boolean>;
  activeYear: number;
}

export function CVEStatusIndicator({ isSearching, loadingYears, activeYear }: CVEStatusIndicatorProps) {
  const { t } = useLanguage();

  if (isSearching) {
    return (
      <div className="text-sm text-muted-foreground">
        {t('cve.search_all_years')}
      </div>
    );
  }

  return (
    <div className="text-sm text-muted-foreground">
      {loadingYears[activeYear] ? (
        <div className="flex items-center gap-2">
          <Loader2 className="h-4 w-4 animate-spin" />
          <span>{t('cve.loading_year', { year: activeYear })}</span>
        </div>
      ) : (
        <div className="flex items-center gap-1">
          <Check className="h-4 w-4 text-green-500" />
          <span>
            {t('cve.current_year', { year: activeYear })}
          </span>
        </div>
      )}
    </div>
  );
}
